(() => {
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const coarse = matchMedia('(pointer: coarse)').matches;
  const hex = h => { h = (h || '').trim().replace('#', ''); if (h.length === 3) h = h.replace(/./g, c => c + c); const n = parseInt(h, 16) || 0; return [n >> 16 & 255, n >> 8 & 255, n & 255]; };
  const lum = c => (c[0] * .299 + c[1] * .587 + c[2] * .114) / 255;
  let seed = 7;
  const rnd = () => { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; };

  const texture = () => {
    const c = document.createElement('canvas'), S = 160;
    c.width = c.height = S;
    const x = c.getContext('2d');
    x.fillStyle = '#7a7a7a'; x.fillRect(0, 0, S, S);
    for (let i = 0; i < 2600; i++) {
      const v = Math.pow(rnd(), 2.2), g = Math.round(60 + v * 195), s = rnd() < .12 ? 3 : 2;
      x.fillStyle = `rgb(${g},${g},${g})`;
      x.fillRect(Math.floor(rnd() * S), Math.floor(rnd() * S), s, s);
    }
    for (let i = 0; i < 26; i++) {
      const px = rnd() * S, py = rnd() * S, r = 2 + rnd() * 3;
      const gr = x.createRadialGradient(px, py, 0, px, py, r * 2);
      gr.addColorStop(0, 'rgba(255,255,255,1)'); gr.addColorStop(1, 'rgba(255,255,255,0)');
      x.fillStyle = gr; x.fillRect(px - r * 2, py - r * 2, r * 4, r * 4);
    }
    return c.toDataURL('image/png');
  };

  const star = (ctx, cx, cy, R, r) => {
    ctx.beginPath();
    for (let i = 0; i < 10; i++) {
      const a = -Math.PI / 2 + i * Math.PI / 5, rr = i % 2 ? r : R;
      i ? ctx.lineTo(cx + Math.cos(a) * rr, cy + Math.sin(a) * rr) : ctx.moveTo(cx + Math.cos(a) * rr, cy + Math.sin(a) * rr);
    }
    ctx.closePath();
  };

  const glintSprite = (() => {
    let c;
    return () => {
      if (c) return c;
      c = document.createElement('canvas'); c.width = c.height = 64;
      const x = c.getContext('2d'), g = x.createRadialGradient(32, 32, 0, 32, 32, 10);
      g.addColorStop(0, 'rgba(255,255,255,1)'); g.addColorStop(.35, 'rgba(255,248,235,.65)'); g.addColorStop(1, 'rgba(255,240,220,0)');
      x.fillStyle = g; x.fillRect(0, 0, 64, 64);
      x.globalCompositeOperation = 'lighter';
      [[64, 3], [3, 64]].forEach(([w, h]) => {
        const l = x.createLinearGradient(32 - w / 2, 32 - h / 2, 32 + w / 2, 32 + h / 2);
        l.addColorStop(0, 'rgba(255,255,255,0)'); l.addColorStop(.5, 'rgba(255,255,255,.95)'); l.addColorStop(1, 'rgba(255,255,255,0)');
        x.fillStyle = l; x.fillRect(32 - w / 2, 32 - h / 2, w, h);
      });
      return c;
    };
  })();

  const drawArt = (ctx, W, H, el) => {
    const word = (el.dataset.word || 'Shine').toUpperCase();
    const cols = (el.dataset.colors || '#ff4f9a,#b45cff,#ffc94a').split(',').map(s => s.trim());
    const art = el.dataset.art;
    const fill = (x0, x1) => { const g = ctx.createLinearGradient(x0, 0, x1, 0); cols.forEach((c, i) => g.addColorStop(cols.length > 1 ? i / (cols.length - 1) : 0, c)); return g; };
    ctx.textBaseline = 'alphabetic';
    if (art === 'word') {
      const w = +el.dataset.weight || 800, word2 = el.dataset.word || 'Sparkle';
      ctx.font = `${w} 100px PTSGeist, system-ui, sans-serif`;
      const m = ctx.measureText(word2), fs = Math.min(H * .62, 100 * W * .84 / m.width);
      ctx.font = `${w} ${fs}px PTSGeist, system-ui, sans-serif`;
      const tw = ctx.measureText(word2).width, x = (W - tw) / 2, y = H / 2 + fs * .36;
      ctx.fillStyle = fill(x, x + tw);
      ctx.fillText(word2, x, y);
      return;
    }
    const wide = W / H > 1.15;
    ctx.font = `900 100px PTSGeist, system-ui, sans-serif`;
    const mw = ctx.measureText(word).width / 100;
    if (wide) {
      const fs = Math.min(H * .42, W * .58 / mw), tw = mw * fs, sr = fs * .62, gap = fs * .22;
      const total = sr * 2 + gap + tw, x0 = (W - total) / 2, cy = H * .5;
      ctx.fillStyle = fill(x0, x0 + total);
      star(ctx, x0 + sr, cy - fs * .02, sr, sr * .46); ctx.fill();
      ctx.font = `900 ${fs}px PTSGeist, system-ui, sans-serif`;
      ctx.fillText(word, x0 + sr * 2 + gap, cy + fs * .36);
      const bx = x0 + sr * 2 + gap, by = cy + fs * .56;
      ctx.beginPath(); ctx.roundRect ? ctx.roundRect(bx, by, tw, fs * .12, fs * .06) : ctx.rect(bx, by, tw, fs * .12); ctx.fill();
    } else {
      const fs = Math.min(W * .84 / mw, H * .26), tw = mw * fs, sr = Math.min(W, H) * .2, x = (W - tw) / 2;
      const cy = H * .34;
      ctx.fillStyle = fill(x, x + tw);
      star(ctx, W / 2, cy, sr, sr * .46); ctx.fill();
      ctx.font = `900 ${fs}px PTSGeist, system-ui, sans-serif`;
      const ty = cy + sr + fs * .98;
      ctx.fillText(word, x, ty);
      ctx.beginPath(); ctx.roundRect ? ctx.roundRect(x, ty + fs * .2, tw, fs * .12, fs * .06) : ctx.rect(x, ty + fs * .2, tw, fs * .12); ctx.fill();
    }
  };

  const Sparkle = el => {
    const cv = el.querySelector('canvas'), ctx = cv.getContext('2d');
    let W = 0, H = 0, k = 1, cell = 3, N = 0, mask, flat, base, img, d32, fx, fy, nx, ny, nz, cr, cg, cb, amb, iri, cellStart;
    let mode = 'glitter', shirt = hex(el.dataset.shirt || '#141519');
    const L = { x: .62, y: .3 }, T = { x: .62, y: .3 };
    let raf = 0, visible = false, lastInput = -1e9, built = false, dirty = true, tilt = false;

    const fabric = () => {
      const buf = new Uint8ClampedArray(W * H * 4), light = lum(shirt) > .5, amp = light ? 7 : 9;
      for (let y = 0; y < H; y++) {
        const vy = (y / H - .5);
        for (let x = 0; x < W; x++) {
          const vx = (x / W - .5), v = 1 - (vx * vx + vy * vy) * (light ? .18 : .5);
          const knit = ((x >> 1) + (y >> 1)) & 1 ? 1 : -1, n = (Math.random() - .5) * amp + knit * 1.5;
          const i = (y * W + x) * 4;
          buf[i] = shirt[0] * v + n; buf[i + 1] = shirt[1] * v + n; buf[i + 2] = shirt[2] * v + n; buf[i + 3] = 255;
        }
      }
      return buf;
    };

    const build = () => {
      const r = cv.getBoundingClientRect();
      if (!r.width) return false;
      k = Math.min(window.devicePixelRatio || 1, el.dataset.art === 'word' ? 2 : 1.5);
      W = Math.round(r.width * k); H = Math.round(r.height * k);
      cv.width = W; cv.height = H;
      cell = Math.max(2, Math.round((el.dataset.art === 'word' ? 2.6 : 2.4) * k));
      const off = document.createElement('canvas'); off.width = W; off.height = H;
      const o = off.getContext('2d');
      drawArt(o, W, H, el);
      const src = o.getImageData(0, 0, W, H).data;
      mask = new Uint8Array(W * H);
      const bg = fabric();
      flat = new Uint8ClampedArray(bg); base = new Uint8ClampedArray(bg);
      for (let p = 0, q = 0; p < W * H; p++, q += 4) {
        const a = src[q + 3] / 255;
        if (!a) continue;
        if (a > .45) mask[p] = 1;
        const t = (bg[q] + bg[q + 1] + bg[q + 2]) / 765, tex = .96 + (t - lum(shirt)) * .5;
        flat[q] = (src[q] * tex) * a + bg[q] * (1 - a);
        flat[q + 1] = (src[q + 1] * tex) * a + bg[q + 1] * (1 - a);
        flat[q + 2] = (src[q + 2] * tex) * a + bg[q + 2] * (1 - a);
        base[q] = flat[q] * .6 + bg[q] * .4 * (1 - a); base[q + 1] = flat[q + 1] * .6 + bg[q + 1] * .4 * (1 - a); base[q + 2] = flat[q + 2] * .6 + bg[q + 2] * .4 * (1 - a);
      }
      const cols = Math.ceil(W / cell), rows = Math.ceil(H / cell), cap = cols * rows;
      fx = new Float32Array(cap); fy = new Float32Array(cap); nx = new Float32Array(cap); ny = new Float32Array(cap); nz = new Float32Array(cap);
      cr = new Uint8ClampedArray(cap); cg = new Uint8ClampedArray(cap); cb = new Uint8ClampedArray(cap); amb = new Float32Array(cap); iri = new Uint8Array(cap); cellStart = new Int32Array(cap);
      N = 0;
      seed = 11;
      for (let gy = 0; gy < rows; gy++) {
        for (let gx = 0; gx < cols; gx++) {
          const ox = (gy & 1) ? Math.floor(cell / 2) : 0;
          const x0 = gx * cell + ox, y0 = gy * cell;
          let hit = 0, sr = 0, sg = 0, sb = 0;
          for (let yy = y0; yy < Math.min(H, y0 + cell); yy++) for (let xx = x0; xx < Math.min(W, x0 + cell); xx++) {
            const p = yy * W + xx;
            if (mask[p]) { hit++; sr += src[p * 4]; sg += src[p * 4 + 1]; sb += src[p * 4 + 2]; }
          }
          if (!hit) continue;
          const th = Math.acos(1 - rnd() * .42), ph = rnd() * Math.PI * 2;
          fx[N] = x0 + cell / 2; fy[N] = y0 + cell / 2;
          nx[N] = Math.sin(th) * Math.cos(ph); ny[N] = Math.sin(th) * Math.sin(ph); nz[N] = Math.cos(th);
          cr[N] = sr / hit; cg[N] = sg / hit; cb[N] = sb / hit;
          amb[N] = .5 + rnd() * .46;
          iri[N] = rnd() < .16 ? 1 + Math.floor(rnd() * 3) : 0;
          cellStart[N] = y0 * W + x0;
          N++;
        }
      }
      img = ctx.createImageData(W, H);
      d32 = new Uint32Array(img.data.buffer);
      built = true; dirty = true;
      return true;
    };

    const glints = [];
    const render = () => {
      if (!built) return;
      const data = img.data;
      if (mode === 'flat') { data.set(flat); ctx.putImageData(img, 0, 0); return; }
      data.set(base);
      const lx = L.x * W, ly = L.y * H, lz = Math.max(W, H) * .55;
      glints.length = 0;
      for (let f = 0; f < N; f++) {
        let dx = lx - fx[f], dy = ly - fy[f];
        const il = 1 / Math.sqrt(dx * dx + dy * dy + lz * lz);
        let hx = dx * il, hy = dy * il, hz = lz * il + 1;
        const ih = 1 / Math.sqrt(hx * hx + hy * hy + hz * hz);
        let dd = (nx[f] * hx + ny[f] * hy + nz[f] * hz) * ih;
        if (dd < 0) dd = 0;
        let s = dd * dd; s *= s; s *= s; s *= s; s *= s; s *= s;
        const s2 = s > 1 ? 1 : s;
        const a = amb[f] * (.68 + .32 * dd);
        let r = cr[f] * a, g = cg[f] * a, b = cb[f] * a;
        if (s2 > .002) {
          let hr = 255, hg = 250, hb = 240;
          if (iri[f]) { const t = (fx[f] / W + fy[f] / H + L.x) * 6.28 + iri[f] * 2.1; hr = 190 + 65 * Math.cos(t); hg = 190 + 65 * Math.cos(t - 2.1); hb = 190 + 65 * Math.cos(t + 2.1); }
          const m = .55 + .45 * s2;
          r += (hr * .78 + cr[f] * .22 - r) * s2 * m * 1.4; g += (hg * .78 + cg[f] * .22 - g) * s2 * m * 1.4; b += (hb * .78 + cb[f] * .22 - b) * s2 * m * 1.4;
          if (s2 > .55 && glints.length < 70) glints.push(f, s2);
        }
        if (r > 255) r = 255; if (g > 255) g = 255; if (b > 255) b = 255;
        const col = (255 << 24) | (b << 16) | (g << 8) | r;
        const st = cellStart[f], x0 = st % W, y0 = (st - x0) / W;
        const xe = Math.min(W, x0 + cell), ye = Math.min(H, y0 + cell);
        for (let yy = y0; yy < ye; yy++) {
          const row = yy * W;
          for (let xx = x0; xx < xe; xx++) { const p = row + xx; if (mask[p]) d32[p] = col; }
        }
      }
      ctx.putImageData(img, 0, 0);
      if (glints.length) {
        const sp = glintSprite();
        ctx.globalCompositeOperation = 'lighter';
        for (let i = 0; i < glints.length; i += 2) {
          const f = glints[i], v = glints[i + 1], sz = cell * (5 + v * 9) * (amb[f] + .3);
          ctx.globalAlpha = Math.min(1, (v - .5) * 2.2);
          ctx.drawImage(sp, fx[f] - sz / 2, fy[f] - sz / 2, sz, sz);
        }
        ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over';
      }
    };

    const tick = now => {
      raf = 0;
      if (!visible || document.hidden) return;
      const idle = now - lastInput > 2600;
      if (!still && idle && !tilt) {
        const t = now / 1000;
        T.x = .5 + .36 * Math.sin(t * .55) + .08 * Math.sin(t * 1.7);
        T.y = .32 + .22 * Math.sin(t * .37 + 1) + .05 * Math.cos(t * 1.3);
      }
      const ex = T.x - L.x, ey = T.y - L.y;
      const moving = Math.abs(ex) + Math.abs(ey) > .0008;
      L.x += ex * (still ? 1 : .14); L.y += ey * (still ? 1 : .14);
      if (moving || dirty) { render(); dirty = false; }
      if (mode === 'glitter' && (!still || moving)) raf = requestAnimationFrame(tick);
    };
    const kick = () => { if (!raf && visible) raf = requestAnimationFrame(tick); };

    const api = {
      el,
      setMode(m) { mode = m; dirty = true; kick(); },
      setShirt(c) { shirt = hex(c); el.style.setProperty('--shirt', c); el.dataset.shirt = c; build(); kick(); },
      setLight(x, y, user = true) { T.x = x; if (y != null) T.y = y; if (user) lastInput = performance.now(); kick(); },
      setTilt(v) { tilt = v; },
      rebuild() { build(); kick(); },
      show(v) { visible = v; if (v) { if (!built) build(); kick(); } },
      resume() { kick(); }
    };

    const pos = e => { const r = cv.getBoundingClientRect(); return [(e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height]; };
    el.addEventListener('pointermove', e => { const [x, y] = pos(e); api.setLight(x, y); });
    el.addEventListener('pointerdown', e => { const [x, y] = pos(e); api.setLight(x, y); });
    let rt = 0;
    new ResizeObserver(() => { clearTimeout(rt); rt = setTimeout(() => { if (built || visible) build(), kick(); }, 120); }).observe(el);
    return api;
  };

  const initSim = (sec, sim) => {
    const stage = sec.closest('.ptg-sim') || sec;
    const hint = stage.querySelector('[data-ptg-hint]');
    if (hint && coarse && hint.dataset.touch) hint.textContent = hint.dataset.touch;
    const modes = [...stage.querySelectorAll('[data-ptg-mode]')];
    const bg = stage.querySelector('[data-ptg-badge-glitter]'), bf = stage.querySelector('[data-ptg-badge-flat]');
    modes.forEach(b => b.addEventListener('click', () => {
      modes.forEach(o => o.setAttribute('aria-pressed', o === b ? 'true' : 'false'));
      sim.setMode(b.dataset.ptgMode);
      if (bg) { bg.hidden = b.dataset.ptgMode !== 'glitter'; bf.hidden = !bg.hidden; }
    }));
    const sw = [...stage.querySelectorAll('[data-ptg-shirt]')];
    sw.forEach(b => b.addEventListener('click', () => { sw.forEach(o => o.setAttribute('aria-pressed', o === b ? 'true' : 'false')); sim.setShirt(b.dataset.ptgShirt); }));
    const range = stage.querySelector('[data-ptg-light]');
    if (range) range.addEventListener('input', () => { const v = +range.value / 100; sim.setLight(.08 + v * .84, .3 - .12 * Math.sin(v * Math.PI)); });
    const tb = stage.querySelector('[data-ptg-tilt]');
    const onTilt = e => {
      if (e.gamma == null) return;
      sim.setTilt(true);
      const x = Math.max(0, Math.min(1, .5 + e.gamma / 50)), y = Math.max(0, Math.min(1, (e.beta - 20) / 60));
      sim.setLight(x, y);
    };
    if (coarse && window.DeviceOrientationEvent) {
      if (typeof DeviceOrientationEvent.requestPermission === 'function') {
        if (tb) {
          tb.hidden = false;
          tb.addEventListener('click', () => DeviceOrientationEvent.requestPermission().then(r => { if (r === 'granted') { addEventListener('deviceorientation', onTilt); tb.setAttribute('aria-pressed', 'true'); tb.classList.add('is-on'); } }).catch(() => {}));
        }
      } else addEventListener('deviceorientation', onTilt);
    }
  };

  const initLens = (box, sim) => {
    const r = box.querySelector('[data-ptg-weight]'), out = box.querySelector('[data-ptg-weight-read]');
    if (!r) return;
    let t = 0;
    r.addEventListener('input', () => {
      sim.el.dataset.weight = r.value;
      out.textContent = +r.value <= 300 ? out.dataset.thin : out.dataset.bold;
      cancelAnimationFrame(t); t = requestAnimationFrame(() => sim.rebuild());
    });
  };

  const initCheck = box => {
    const chips = [...box.querySelectorAll('.pts-chip')], v = box.querySelector('[data-ptg-verdict]');
    const panes = [...v.querySelectorAll('.pts-verdict__pane')];
    const update = () => {
      const on = chips.filter(c => c.getAttribute('aria-pressed') === 'true').map(c => c.dataset.side);
      const state = on.includes('test') ? 'test' : on.length ? 'good' : 'idle';
      if (v.dataset.state === state) return;
      v.dataset.state = state;
      panes.forEach(p => { p.hidden = p.dataset.for !== state; });
    };
    chips.forEach(c => c.addEventListener('click', () => { c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); update(); }));
  };

  const initSize = box => {
    const chips = [...box.querySelectorAll('.ptg-size__chip')], zone = box.querySelector('[data-ptg-zone]');
    const lab = box.querySelector('[data-ptg-zone-lab]'), rl = box.querySelector('[data-ptg-size-label]'), rp = box.querySelector('[data-ptg-size-place]'), rf = box.querySelector('[data-ptg-size-fit]');
    if (!chips.length || !zone) return;
    const pick = c => {
      const n = (c.dataset.size.match(/[\d.]+/g) || []).map(Number);
      if (n.length < 2) return;
      const [w, h] = n, pocket = w <= 4 && h <= 4;
      const cx = pocket ? 4.6 : 0, top = pocket ? 4.2 : 3.6;
      zone.style.left = ((cx - w / 2 + 17) / 34 * 100) + '%';
      zone.style.top = ((top + 1.5) / 31 * 100) + '%';
      zone.style.width = (w / 34 * 100) + '%';
      zone.style.height = (h / 31 * 100) + '%';
      zone.hidden = false;
      const name = `${w} × ${h} in`, place = pocket ? box.dataset.pocket : box.dataset.center;
      lab.textContent = name;
      rl.textContent = name; rp.textContent = place; rf.textContent = c.dataset.fit;
      chips.forEach(o => o.setAttribute('aria-pressed', o === c ? 'true' : 'false'));
    };
    chips.forEach(c => c.addEventListener('click', () => pick(c)));
    const want = (box.dataset.default || '').replace(/\s/g, '');
    pick(chips.find(c => c.dataset.size.replace(/\s/g, '') === want) || chips[chips.length - 1]);
  };

  const init = root => {
    if (root.dataset.ptgReady) return;
    root.dataset.ptgReady = '1';
    try { root.style.setProperty('--ptg-tex', `url(${texture()})`); } catch (_) {}
    const sims = [];
    root.querySelectorAll('[data-ptg-sim]').forEach(el => {
      const s = Sparkle(el);
      sims.push(s);
      if (el.closest('.ptg-sim')) initSim(el.closest('.ptg-sim'), s);
      if (el.closest('.ptg-lens')) initLens(el.closest('.ptg-lens'), s);
    });
    root.querySelectorAll('[data-ptg-check]').forEach(initCheck);
    root.querySelectorAll('[data-ptg-size]').forEach(initSize);
    const ready = document.fonts && document.fonts.load ? Promise.all([document.fonts.load('900 40px PTSGeist'), document.fonts.load('200 40px PTSGeist')]).catch(() => {}) : Promise.resolve();
    ready.then(() => {
      const io = new IntersectionObserver(es => es.forEach(e => { const s = sims.find(x => x.el === e.target); if (s) s.show(e.isIntersecting); }), { rootMargin: '120px 0px' });
      sims.forEach(s => io.observe(s.el));
    });
    const live = new IntersectionObserver(es => es.forEach(e => e.target.classList.toggle('is-live', e.isIntersecting)), { rootMargin: '0px' });
    root.querySelectorAll('[data-ptg-live]').forEach(el => live.observe(el));
    document.addEventListener('visibilitychange', () => { if (!document.hidden) sims.forEach(s => s.resume()); });
  };

  const boot = () => document.querySelectorAll('[data-ptg]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
